export default {
    byCollection(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('collectionId', id).get()
            )
        )
    }
}
